/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUsuario = /* GraphQL */ `
  mutation CreateUsuario(
    $input: CreateUsuarioInput!
    $condition: ModelUsuarioConditionInput
  ) {
    createUsuario(input: $input, condition: $condition) {
      id
      name
      email
      proyectos {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      logs {
        nextToken
        __typename
      }
      creditos {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      creditosId
      perfil {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        especialidades
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      perfilId
      isActive
      createdAt
      updatedAt
      institucionUsuariosId
      __typename
    }
  }
`;
export const updateUsuario = /* GraphQL */ `
  mutation UpdateUsuario(
    $input: UpdateUsuarioInput!
    $condition: ModelUsuarioConditionInput
  ) {
    updateUsuario(input: $input, condition: $condition) {
      id
      name
      email
      proyectos {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      logs {
        nextToken
        __typename
      }
      creditos {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      creditosId
      perfil {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        especialidades
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      perfilId
      isActive
      createdAt
      updatedAt
      institucionUsuariosId
      __typename
    }
  }
`;
export const deleteUsuario = /* GraphQL */ `
  mutation DeleteUsuario(
    $input: DeleteUsuarioInput!
    $condition: ModelUsuarioConditionInput
  ) {
    deleteUsuario(input: $input, condition: $condition) {
      id
      name
      email
      proyectos {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      logs {
        nextToken
        __typename
      }
      creditos {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      creditosId
      perfil {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        especialidades
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      perfilId
      isActive
      createdAt
      updatedAt
      institucionUsuariosId
      __typename
    }
  }
`;
export const createControlError = /* GraphQL */ `
  mutation CreateControlError(
    $input: CreateControlErrorInput!
    $condition: ModelControlErrorConditionInput
  ) {
    createControlError(input: $input, condition: $condition) {
      id
      browser
      browserVersion
      os
      osVersion
      deviceType
      url
      info
      servicio
      mensaje
      stackTrace
      usuarioId
      sessionId
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateControlError = /* GraphQL */ `
  mutation UpdateControlError(
    $input: UpdateControlErrorInput!
    $condition: ModelControlErrorConditionInput
  ) {
    updateControlError(input: $input, condition: $condition) {
      id
      browser
      browserVersion
      os
      osVersion
      deviceType
      url
      info
      servicio
      mensaje
      stackTrace
      usuarioId
      sessionId
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteControlError = /* GraphQL */ `
  mutation DeleteControlError(
    $input: DeleteControlErrorInput!
    $condition: ModelControlErrorConditionInput
  ) {
    deleteControlError(input: $input, condition: $condition) {
      id
      browser
      browserVersion
      os
      osVersion
      deviceType
      url
      info
      servicio
      mensaje
      stackTrace
      usuarioId
      sessionId
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCreditos = /* GraphQL */ `
  mutation CreateCreditos(
    $input: CreateCreditosInput!
    $condition: ModelCreditosConditionInput
  ) {
    createCreditos(input: $input, condition: $condition) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      creditosUsados
      tokensIngresados
      tokensRecibidos
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCreditos = /* GraphQL */ `
  mutation UpdateCreditos(
    $input: UpdateCreditosInput!
    $condition: ModelCreditosConditionInput
  ) {
    updateCreditos(input: $input, condition: $condition) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      creditosUsados
      tokensIngresados
      tokensRecibidos
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCreditos = /* GraphQL */ `
  mutation DeleteCreditos(
    $input: DeleteCreditosInput!
    $condition: ModelCreditosConditionInput
  ) {
    deleteCreditos(input: $input, condition: $condition) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      creditosUsados
      tokensIngresados
      tokensRecibidos
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProyecto = /* GraphQL */ `
  mutation CreateProyecto(
    $input: CreateProyectoInput!
    $condition: ModelProyectoConditionInput
  ) {
    createProyecto(input: $input, condition: $condition) {
      id
      name
      tipoEstructura
      nivelCurso
      asignaturas
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      resultados {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      projectUserInputs {
        nextToken
        __typename
      }
      organizacionId
      isCloneProject
      idProyectoFuente
      isEliminated
      createdAt
      updatedAt
      usuarioProyectosId
      institucionProyectosId
      __typename
    }
  }
`;
export const updateProyecto = /* GraphQL */ `
  mutation UpdateProyecto(
    $input: UpdateProyectoInput!
    $condition: ModelProyectoConditionInput
  ) {
    updateProyecto(input: $input, condition: $condition) {
      id
      name
      tipoEstructura
      nivelCurso
      asignaturas
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      resultados {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      projectUserInputs {
        nextToken
        __typename
      }
      organizacionId
      isCloneProject
      idProyectoFuente
      isEliminated
      createdAt
      updatedAt
      usuarioProyectosId
      institucionProyectosId
      __typename
    }
  }
`;
export const deleteProyecto = /* GraphQL */ `
  mutation DeleteProyecto(
    $input: DeleteProyectoInput!
    $condition: ModelProyectoConditionInput
  ) {
    deleteProyecto(input: $input, condition: $condition) {
      id
      name
      tipoEstructura
      nivelCurso
      asignaturas
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      resultados {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      projectUserInputs {
        nextToken
        __typename
      }
      organizacionId
      isCloneProject
      idProyectoFuente
      isEliminated
      createdAt
      updatedAt
      usuarioProyectosId
      institucionProyectosId
      __typename
    }
  }
`;
export const createResultado = /* GraphQL */ `
  mutation CreateResultado(
    $input: CreateResultadoInput!
    $condition: ModelResultadoConditionInput
  ) {
    createResultado(input: $input, condition: $condition) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      resultado
      promptLLM
      in_tokens
      out_tokens
      calificacion
      createdAt
      updatedAt
      proyectoResultadosId
      __typename
    }
  }
`;
export const updateResultado = /* GraphQL */ `
  mutation UpdateResultado(
    $input: UpdateResultadoInput!
    $condition: ModelResultadoConditionInput
  ) {
    updateResultado(input: $input, condition: $condition) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      resultado
      promptLLM
      in_tokens
      out_tokens
      calificacion
      createdAt
      updatedAt
      proyectoResultadosId
      __typename
    }
  }
`;
export const deleteResultado = /* GraphQL */ `
  mutation DeleteResultado(
    $input: DeleteResultadoInput!
    $condition: ModelResultadoConditionInput
  ) {
    deleteResultado(input: $input, condition: $condition) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      resultado
      promptLLM
      in_tokens
      out_tokens
      calificacion
      createdAt
      updatedAt
      proyectoResultadosId
      __typename
    }
  }
`;
export const createProjectUserInput = /* GraphQL */ `
  mutation CreateProjectUserInput(
    $input: CreateProjectUserInputInput!
    $condition: ModelProjectUserInputConditionInput
  ) {
    createProjectUserInput(input: $input, condition: $condition) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      input
      createdAt
      updatedAt
      proyectoProjectUserInputsId
      __typename
    }
  }
`;
export const updateProjectUserInput = /* GraphQL */ `
  mutation UpdateProjectUserInput(
    $input: UpdateProjectUserInputInput!
    $condition: ModelProjectUserInputConditionInput
  ) {
    updateProjectUserInput(input: $input, condition: $condition) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      input
      createdAt
      updatedAt
      proyectoProjectUserInputsId
      __typename
    }
  }
`;
export const deleteProjectUserInput = /* GraphQL */ `
  mutation DeleteProjectUserInput(
    $input: DeleteProjectUserInputInput!
    $condition: ModelProjectUserInputConditionInput
  ) {
    deleteProjectUserInput(input: $input, condition: $condition) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      input
      createdAt
      updatedAt
      proyectoProjectUserInputsId
      __typename
    }
  }
`;
export const createLog = /* GraphQL */ `
  mutation CreateLog(
    $input: CreateLogInput!
    $condition: ModelLogConditionInput
  ) {
    createLog(input: $input, condition: $condition) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      detail
      action
      createdAt
      updatedAt
      usuarioLogsId
      __typename
    }
  }
`;
export const updateLog = /* GraphQL */ `
  mutation UpdateLog(
    $input: UpdateLogInput!
    $condition: ModelLogConditionInput
  ) {
    updateLog(input: $input, condition: $condition) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      detail
      action
      createdAt
      updatedAt
      usuarioLogsId
      __typename
    }
  }
`;
export const deleteLog = /* GraphQL */ `
  mutation DeleteLog(
    $input: DeleteLogInput!
    $condition: ModelLogConditionInput
  ) {
    deleteLog(input: $input, condition: $condition) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      detail
      action
      createdAt
      updatedAt
      usuarioLogsId
      __typename
    }
  }
`;
export const createInstitucion = /* GraphQL */ `
  mutation CreateInstitucion(
    $input: CreateInstitucionInput!
    $condition: ModelInstitucionConditionInput
  ) {
    createInstitucion(input: $input, condition: $condition) {
      id
      name
      tipo
      usuarios {
        nextToken
        __typename
      }
      proyectos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInstitucion = /* GraphQL */ `
  mutation UpdateInstitucion(
    $input: UpdateInstitucionInput!
    $condition: ModelInstitucionConditionInput
  ) {
    updateInstitucion(input: $input, condition: $condition) {
      id
      name
      tipo
      usuarios {
        nextToken
        __typename
      }
      proyectos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInstitucion = /* GraphQL */ `
  mutation DeleteInstitucion(
    $input: DeleteInstitucionInput!
    $condition: ModelInstitucionConditionInput
  ) {
    deleteInstitucion(input: $input, condition: $condition) {
      id
      name
      tipo
      usuarios {
        nextToken
        __typename
      }
      proyectos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createWhitelistUser = /* GraphQL */ `
  mutation CreateWhitelistUser(
    $input: CreateWhitelistUserInput!
    $condition: ModelWhitelistUserConditionInput
  ) {
    createWhitelistUser(input: $input, condition: $condition) {
      id
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateWhitelistUser = /* GraphQL */ `
  mutation UpdateWhitelistUser(
    $input: UpdateWhitelistUserInput!
    $condition: ModelWhitelistUserConditionInput
  ) {
    updateWhitelistUser(input: $input, condition: $condition) {
      id
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteWhitelistUser = /* GraphQL */ `
  mutation DeleteWhitelistUser(
    $input: DeleteWhitelistUserInput!
    $condition: ModelWhitelistUserConditionInput
  ) {
    deleteWhitelistUser(input: $input, condition: $condition) {
      id
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPerfil = /* GraphQL */ `
  mutation CreatePerfil(
    $input: CreatePerfilInput!
    $condition: ModelPerfilConditionInput
  ) {
    createPerfil(input: $input, condition: $condition) {
      id
      nombre
      apellido
      tel
      cargo
      RBD
      colegio
      pais
      ciudad
      especialidades
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePerfil = /* GraphQL */ `
  mutation UpdatePerfil(
    $input: UpdatePerfilInput!
    $condition: ModelPerfilConditionInput
  ) {
    updatePerfil(input: $input, condition: $condition) {
      id
      nombre
      apellido
      tel
      cargo
      RBD
      colegio
      pais
      ciudad
      especialidades
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePerfil = /* GraphQL */ `
  mutation DeletePerfil(
    $input: DeletePerfilInput!
    $condition: ModelPerfilConditionInput
  ) {
    deletePerfil(input: $input, condition: $condition) {
      id
      nombre
      apellido
      tel
      cargo
      RBD
      colegio
      pais
      ciudad
      especialidades
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createChatAgentSession = /* GraphQL */ `
  mutation CreateChatAgentSession(
    $input: CreateChatAgentSessionInput!
    $condition: ModelChatAgentSessionConditionInput
  ) {
    createChatAgentSession(input: $input, condition: $condition) {
      id
      userId
      sessionName
      proyectoId
      resultadoId
      modelName
      modelId
      totalTokens
      creditosDescontados
      conversionFactor
      conversionUnit
      mensajes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateChatAgentSession = /* GraphQL */ `
  mutation UpdateChatAgentSession(
    $input: UpdateChatAgentSessionInput!
    $condition: ModelChatAgentSessionConditionInput
  ) {
    updateChatAgentSession(input: $input, condition: $condition) {
      id
      userId
      sessionName
      proyectoId
      resultadoId
      modelName
      modelId
      totalTokens
      creditosDescontados
      conversionFactor
      conversionUnit
      mensajes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteChatAgentSession = /* GraphQL */ `
  mutation DeleteChatAgentSession(
    $input: DeleteChatAgentSessionInput!
    $condition: ModelChatAgentSessionConditionInput
  ) {
    deleteChatAgentSession(input: $input, condition: $condition) {
      id
      userId
      sessionName
      proyectoId
      resultadoId
      modelName
      modelId
      totalTokens
      creditosDescontados
      conversionFactor
      conversionUnit
      mensajes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createChatAgentMessage = /* GraphQL */ `
  mutation CreateChatAgentMessage(
    $input: CreateChatAgentMessageInput!
    $condition: ModelChatAgentMessageConditionInput
  ) {
    createChatAgentMessage(input: $input, condition: $condition) {
      id
      chatSessionId
      actor
      instruction
      content
      tokensUsed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateChatAgentMessage = /* GraphQL */ `
  mutation UpdateChatAgentMessage(
    $input: UpdateChatAgentMessageInput!
    $condition: ModelChatAgentMessageConditionInput
  ) {
    updateChatAgentMessage(input: $input, condition: $condition) {
      id
      chatSessionId
      actor
      instruction
      content
      tokensUsed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteChatAgentMessage = /* GraphQL */ `
  mutation DeleteChatAgentMessage(
    $input: DeleteChatAgentMessageInput!
    $condition: ModelChatAgentMessageConditionInput
  ) {
    deleteChatAgentMessage(input: $input, condition: $condition) {
      id
      chatSessionId
      actor
      instruction
      content
      tokensUsed
      createdAt
      updatedAt
      __typename
    }
  }
`;
